import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import EventBus from 'diagram-js/lib/core/EventBus';
import { NodeType } from '@ispm/shared/bpmn-io/node-type';
import { PathwaysModeling } from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import { ifNodeOfType } from '@ispm-client/modules/bpmn-modeler/bpmn/Interceptors/command-interceptor-utils';
import { CommandType } from '@ispm/shared/bpmn-io/bpmn-js';
import { END_NODE_ID, endEvent } from '../../../../../../../ispm-web/shared/modules/bpmn/diagram-element-terms';

export class EndNodeAppender extends CommandInterceptor {


  constructor(eventBus: EventBus, private pathwaysModeling: PathwaysModeling, private elementRegistry,
              private elementFactory, private autoPlace, private modeling) {
    super(eventBus);
    super.postExecuted([CommandType.APPEND_NODE], ifNodeOfType((this.appendEndNode.bind(this)), NodeType.treatment));
  }

  appendEndNode(event) {
    const context = event.context;
    const entryNode = context.node;
    if (entryNode.outgoing.length === 0) {
      // Look for existing end node.
      let endNode = this.elementRegistry.get(END_NODE_ID);
      // Create end node if none exists
      if (!endNode) {
        endNode = this.elementFactory.createShape(Object.assign({
          type: endEvent
        }), { });
        const newNode = this.autoPlace.append(entryNode, endNode);
        this.modeling.updateProperties(newNode, { id : END_NODE_ID});
      } else {
        this.modeling.connect(entryNode, endNode);
      }
    }
  }

}

EndNodeAppender.$inject = [...CommandInterceptor.$inject, 'pathwaysModeling', 'elementRegistry', 'elementFactory', 'autoPlace', 'modeling'];
